<div class="app-full-height px-4 pt-4 space-y-4">
  <app-alert-text *ngIf="transferred$ | async" id="transferred-warning">
    <h2>Warning</h2>
    <p>
      This sale has been marked as transferred by your accounts department. If
      you are not using an accounts integration any changes will need to be
      manually applied on your accounts system.
    </p>
  </app-alert-text>
  <div class="flex flex-col lg:flex-row lg:space-x-4 lg:items-stretch lg:justify-start lg:space-y-0 space-y-4">
    <mat-card appearance="outlined" class="lg:w-1/3 w-full">
      <mat-card-content>
        <h2>Customer</h2>
        <ngx-skeleton-loader *ngIf="customerLoading$ | async; else customerDetails" count="3"
          appearance="line"></ngx-skeleton-loader>
        <ng-template #customerDetails>
          <p>
            <a data-cy="customer-name" matTooltip="View Customer" matTooltip-position="right" md-autohide="false"
              [routerLink]="['/customer', (customer$ | async).id]">
              {{ customer$ | async | customerName }}
            </a>
          </p>
          <p data-cy="customer-address">
            {{ customer$ | async | customerAddress }}
          </p>
          <p data-cy="customer-details">
            {{ customer$ | async | customerContactDetails }}
          </p>
          @if (docket$ | async; as docket) {
          <app-document-contact [contactId]="docket?.contact_id" [customerId]="docket?.customer_id"
            (contactSelected)="updateDocketContact($event)"></app-document-contact>
          }
          <app-integration-relationship-info [customer]="customer$ | async"></app-integration-relationship-info>
        </ng-template>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined" class="lg:w-1/3 w-full">
      <mat-card-content class="text-center">
        <app-sales-docket-info [docketLoading]="docketLoading$ | async" [docket]="docket$ | async"
          (print)="print($event)" (email)="email()"></app-sales-docket-info>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined" class="lg:w-1/3 w-full">
      <mat-card-content class="text-center lg:text-right">
        <app-sale-docket-settings></app-sale-docket-settings>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="flex flex-col w-full">
    <mat-card>
      <mat-card-content class="text-center flex flex-col space-y-6">
        <h2 class="pb-4">Items</h2>
        <app-retail-item-list [docketId]="(docket$ | async)?.id" [canAdd]="(finalized$ | async) === false"
          [canEdit]="(finalized$ | async) === false" [currency]="currency$ | async"
          [currencyRate]="currencyRate$ | async"></app-retail-item-list>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="flex flex-col lg:flex-row w-full lg:gap-x-4">
    <div class="border border-gray-300 p-3 w-full lg:w-2/3">
      <app-signature-section [saleDocket]="docket$ | async" stage="Sale"></app-signature-section>
    </div>
    <mat-card class="w-full lg:w-1/3 lg:ml-auto">
      <mat-card-content>
        <app-price-container-v2 *ngIf="(docketLoading$ | async) === false" [canAddPayments]="finalized$ | async"
          [paymentableId]="(docket$ | async)?.id" [chargeableItems]="paymentContainerCharges$ | async"
          (paymentsChanged)="checkDocketStatus()" [currency]="currency$ | async"
          [currencyRate]="currencyRate$ | async"></app-price-container-v2>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="w-full my-16 flex flex-col justify-start items-stretch gap-y-6">
    <h2>Emails</h2>
    @if(emailListSource$ | async; as source) {
    <app-email-list [source]="source" />
    }
  </div>
</div>
<iframe [style.display]="'none'" frameborder="0" #printFrame></iframe>